export const DASHBOARD_API_URL = '/dashboard/api/dashboards';
export const DASHBOARD_WIDGET_API_URL = '/dashboard/api/widgets';
export const ACTIONS_COLUMN = '_actionsColumn';

const dashboards = 'dashboard-config-widget.';

export const DASHBOARDS_TRANSLATES = {
    id: `${dashboards}id`,
    typeKey: `${dashboards}typeKey`,
    config: `${dashboards}config`,
    name: `${dashboards}name`,
    layout: `${dashboards}layout`,
    hidden: `${dashboards}hidden`,
    editDashboard: `${dashboards}edit-dashboard`,
    createDashboard: `${dashboards}create-dashboard`,
    owner: `${dashboards}owner`,
    dashboards: `${dashboards}dashboards`,
    dashboard: `${dashboards}dashboard`,
    widgets: `${dashboards}widgets`,
    addWidget: `${dashboards}add-widget`,
    editWidget: `${dashboards}edit-widget`,
    selector: `${dashboards}selector`,
    save: `${dashboards}save`,
    cancel: `${dashboards}cancel`,
    copy: `${dashboards}copy`,
    duplicate: `${dashboards}duplicate`,
    paste: `${dashboards}paste`,
    back: `${dashboards}back`,
    copyClipboard: `${dashboards}copy-clipboard`,
    delete: `${dashboards}delete`,
    created: `${dashboards}created`,
    updated: `${dashboards}updated`,
    deleted: `${dashboards}deleted`,
    saved: `${dashboards}saved`,
    create: `${dashboards}create`,
    import: `${dashboards}import`,
    deleteExistingDashboards: `${dashboards}delete-existing-dashboards`,
    export: `${dashboards}export`,
    close: `${dashboards}close`,
    filter: `${dashboards}filter`,
    empty: `${dashboards}empty`,
    info: `${dashboards}info`,
    editor: `${dashboards}editor`,
    samples: `${dashboards}samples`,
    historyChangesBtnTitle: `${dashboards}historyChangesBtnTitle`,
};

export const EDIT_DASHBOARD_EVENT = 'EDIT_DASHBOARD_EVENT';
